import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { linkWithParams } from 'routes';
import { get } from 'lodash';
import AccountPlayersPreview from 'components/account/AccountPlayersPreview';

const mapStateToProps = (state) => {
  return {
    accountId: get(state.account, 'id', 0),
    meta: state.meta.accountPlayersPreview,
    accountPlayers: state.accountPlayers,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAccountPlayer: (id) => {
      const path = {pathname: linkWithParams('accountPlayer', {id})};
      dispatch(push(path));
    },
  }
}

const AccountHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountPlayersPreview)

export default AccountHeaderContainer;
